<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage" id="epigraphPage_01"><p class="epigraphText"><span>The voice of thy brother’s blood crieth unto me<br/>
from the ground…</span></p><p class="epigraphSource"><span>—G<span class="small">ENESIS</span> 4:10</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780743299084_epigraphPage_01.vue?beadc5f0